<template>
  <div>
    <!-- <el-card>
      <el-row>
        <el-col>
          <div class="inputBox">
            <div class="label">班级：</div>
            <el-select
              v-model="classId"
              size="mini"
              placeholder="请选择"
              @change="onChangeClass"
            >
              <el-option
                v-for="item in classList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              style="margin-left: 10px"
              size="mini"
              @click="onClickExport"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-card> -->
    <el-card style="margin-top: 20px">
      <el-table
        border
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        :data="tableData"
        style="width: 100%"
        :span-method="objectSpanMethod"
      >
        <el-table-column prop="OneName" label="维度" align="center">
        </el-table-column>
        <el-table-column prop="TwoName" label="要素" align="center">
        </el-table-column>
        <el-table-column prop="ThreeName" label="观察点" align="center">
        </el-table-column>
        <el-table-column prop="OneOption" label="经常发生" align="center">
        </el-table-column>
        <el-table-column prop="TwoOption" label="偶尔发生" align="center">
        </el-table-column>
        <el-table-column prop="ThreeOption" label="从未发生" align="center">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { GetTableByGrowDetail, GetClassSelect } from "../../api/api";
import uploadUrl from "@/api/api";

export default {
  data() {
    return {
      classId: "",
      userInfo: {},
      classList: [],
      tableData: [],
      spanArr: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    // await this.getClassList();
    await this.GetTableByGrowDetail();
    //console.log(this.$route.query);
  },
  methods: {
    onClickExport() {
      var obj = this.classList.find((obj) => {
        return obj.Id === Number(this.classId);
      });
      //console.log(obj, this.classId);
      let ClassName = this.classId == 0 ? "" : obj.Name;

      window.open(
        `${uploadUrl.uploadUrl}/api/mgd/Eval_Growth/Export_GetTableByGrowDetail?GradeName=${this.$route.query.GradeNameS}&ClassName=${ClassName}&Title="幼儿发展中典型行为观察表"&TempId=${this.$route.query.TempId}&TempDetailId=${this.$route.query.TempDetailId}&CycleId=${this.$route.query.CycleId}&StudyYearId=${this.$route.query.StudyYearId}&ClassId=${this.classId}`,
        "_brank"
      );
    },
    onChangeClass(e) {
      this.GetTableByGrowDetail();
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    //表格单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 2; i++) {
        if (columnIndex == i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;

          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    async GetTableByGrowDetail() {
      let res = await GetTableByGrowDetail({
        TempId: this.$route.query.TempId,
        TempDetailId: this.$route.query.TempDetailId,
        CycleId: this.$route.query.CycleId,
        StudyYearId: this.$route.query.StudyYearId,
        ClassId: this.$route.query.ClassId,
        ClassName: this.$route.query.ClassName,
      });
      if (res.data.success) {
        this.$set(this, "tableData", res.data.response);
        this.rowspan(0, "OneName");
        this.rowspan(1, "TwoName");
      } else {
        this.tableData = [];
      }
    },
    async getClassList(CycleId, GradeName) {
      let xhr = await GetClassSelect({
        StudyYearId: this.$route.query.StudyYearId,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.$route.query.GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        let arr = [
          {
            Name: "全班级",
            Id: 0,
          },
        ];
        this.classList = arr.concat(xhr.data.response);
        this.classId = this.classList[0].Id;
      } else {
        this.classList = [];
        this.classId = "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.inputBox {
  display: flex;
  align-items: center;
}
</style>